// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("./image.res.js");

function semanticsForColumnKey(columnKey, sortOrder) {
  var exit = 0;
  switch (columnKey) {
    case "customer_id" :
        if (sortOrder === "Asc") {
          return "Lowest ID first";
        } else {
          return "Highest ID first";
        }
    case "category" :
    case "group_label" :
        exit = 2;
        break;
    case "nps_score" :
    case "score" :
        exit = 3;
        break;
    case "created_at" :
    case "transaction_date" :
    case "trigger_date" :
        exit = 1;
        break;
    default:
      if (sortOrder === "Asc") {
        return "Ascending";
      } else {
        return "Descending";
      }
  }
  switch (exit) {
    case 1 :
        if (sortOrder === "Asc") {
          return "Oldest first";
        } else {
          return "Newest first";
        }
    case 2 :
        if (sortOrder === "Asc") {
          return "A to Z";
        } else {
          return "Z to A";
        }
    case 3 :
        if (sortOrder === "Asc") {
          return "Lowest first";
        } else {
          return "Highest first";
        }
    
  }
}

function ReportSortBar(props) {
  var onChange = props.onChange;
  var order = props.order;
  var selectedKey = props.selectedKey;
  var sortOptions = props.sortOptions;
  var optionsLen = Belt_List.length(sortOptions);
  var selectedOption = Belt_List.getBy(sortOptions, (function (option) {
          return option.key === selectedKey;
        }));
  var selectedLabel = selectedOption !== undefined ? selectedOption.label : "Column";
  var nextOrder;
  nextOrder = order === "Asc" ? "Desc" : "Asc";
  var currentSemantics = semanticsForColumnKey(selectedKey, order);
  var nextSemantics = semanticsForColumnKey(selectedKey, nextOrder);
  var directionIcon;
  directionIcon = order === "Asc" ? Image$ReactHooksTemplate.sortDirectionAsc : Image$ReactHooksTemplate.sortDirectionDesc;
  var sortDirectionTitle = currentSemantics + ". Click to sort " + nextSemantics + ".";
  if (optionsLen !== 0) {
    return JsxRuntime.jsxs("div", {
                children: [
                  optionsLen !== 1 ? JsxRuntime.jsxs("label", {
                          children: [
                            JsxRuntime.jsx("span", {
                                  children: "Sort column",
                                  className: "sr-only"
                                }),
                            JsxRuntime.jsx("select", {
                                  children: $$Array.of_list(List.map((function (option) {
                                              return JsxRuntime.jsx("option", {
                                                          children: option.label,
                                                          value: option.key
                                                        }, option.key);
                                            }), sortOptions)),
                                  className: "appearance-none h-8 min-w-44 rounded-md border border-gray-200 bg-white py-0 pl-3 pr-8 text-sm font-medium text-gray-800 focus:outline-none focus:ring-2 focus:ring-pigmentblue",
                                  value: selectedKey,
                                  onChange: (function ($$event) {
                                      var nextColumn = $$event.target.value;
                                      Curry._2(onChange, nextColumn, order);
                                    })
                                }),
                            JsxRuntime.jsx("img", {
                                  className: "pointer-events-none absolute right-2.5 top-1/2 h-3.5 w-3.5 transform -translate-y-1/2",
                                  src: Image$ReactHooksTemplate.chevronDown
                                })
                          ],
                          className: "relative inline-flex h-8 items-center"
                        }) : JsxRuntime.jsx("span", {
                          children: selectedLabel,
                          className: "inline-flex h-8 items-center rounded-md bg-ghostwhite px-3 text-sm font-medium text-gray-800"
                        }),
                  JsxRuntime.jsxs("button", {
                        children: [
                          JsxRuntime.jsx("span", {
                                children: currentSemantics,
                                className: "sr-only"
                              }),
                          JsxRuntime.jsx("img", {
                                className: "h-4 w-4",
                                alt: "",
                                src: directionIcon
                              })
                        ],
                        "aria-label": sortDirectionTitle,
                        className: "inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md border border-gray-200 bg-ghostwhite text-gray-700 hover:bg-white focus:outline-none focus:ring-2 focus:ring-pigmentblue",
                        title: sortDirectionTitle,
                        onClick: (function (param) {
                            Curry._2(onChange, selectedKey, nextOrder);
                          })
                      })
                ],
                className: "inline-flex h-40-px shrink-0 items-center gap-2 rounded-lg border border-gray-300 bg-white px-2 shadow-sm"
              });
  } else {
    return null;
  }
}

var make = ReportSortBar;

exports.semanticsForColumnKey = semanticsForColumnKey;
exports.make = make;
/* react/jsx-runtime Not a pure module */
